/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable no-useless-computed-key */
/* eslint-disable no-unused-expressions */

import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import * as yup from "yup";
import { Field, FieldArray, Form, Formik } from "formik";
import Switch from "react-switch";
import IMask from "imask";

import FormContainer from "components/FormContainer";
import BrokingSummary from "components/BrokingSummary";
import Button, { ButtonContainer } from "components/Button";
import ContentCard from "components/ContentCard";
import DialogComponent from "components/Dialog";
import { CheckBox, GridColumnTitle, Label } from "components/Form";
import ComboBox from "components/Form/ComboBox3";
import InputField from "components/Form/InputField";
import { Col, Row } from "components/Grid";
import HasPermission from "components/HasPermission";
import Icon from "components/Icon";
import Layout from "components/Layout";
import Loader from "components/Loader";
import ModalContacts from "components/ModalContacts/index";
import RenderButtons from "components/RenderButtons";
import StepNavigation from "components/StepNavigation";
import { LostCancelButton } from "components/index";
import { sortBy as _sortBy } from "lodash";
import Colors from "constants/Colors";
import { useGetOperationAsync, useOperationInfo } from "services/OperationService";
import {
  useDeleteQuestionnaireAnswer,
  useGetQuestionnaireAnswer,
  useSaveQuestionnaireAnswerSync
} from "services/QuestionnaireAnswerService";
import {
  useCreateMarketChangeQuotation,
  useEndorsementDoc, useGenerateWording,
  useHeaderNbi,
  useImportStatus,
  useInsurerLock,
  useInsurerTaxes,
  useInsurerValues,
  useListStampsContacts,
  useSaveInsurerTaxes,
  useScheduleStatus,
  useUpdateNBIManually,
} from "services/QuoteService";
import { GlobalAuthContext, GlobalLoaderContext } from "store/context";
import { FitinsurAPI, MessageCenter } from "utils";
import MasksHelper from "utils/src/masks";
import {
  groupMultipleFieldQuestions,
  handleQuestionsInitialAdjustments,
} from "./handleQuestionChange";

import {
  GeneralSection,
  TaxRatesSection,
  InsurerTaxesSection,
  FeePayableBySection,
  TaxesRatesBasisGroupSection,
  ObligorPercSection,
  RiskDetailsFacilitySection,
  RiskDetailsSection,
  LossPayeeSection,
  InformationSection,
  SubscriptionAgreementSection,
  FiscalAndRegulatorySection,
  BrokerRemunerationFeeClientSection,
  BrokerRemunerationSection,
  BrokerRemunerationOtherSection,
  BrokerRemunerationDeductionSection,
  SecurityDetailsSection,
  PartysSection,
  DeclarationTemplateSection
} from './sections/index'

import * as Styled from './styles'

export default function MarketComposition(props) {
  const maskHelper = new MasksHelper();

  const [isMAS, setIsMAS] = useState(false);
  const [isNewYork, setIsNewYork] = useState(false);

  var mask = {
    mask: Number,
    scale: 2, // digits after point, 0 for integers
    signed: true, // disallow negative
    thousandsSeparator: ",", // any single char
    padFractionalZeros: true, // if true, then pads zeros at end to the length of scale
    normalizeZeros: false, // appends or removes zeros at ends
    radix: ".", // fractional delimiter
    min: 0,
  };

  var maskPercentage = {
    mask: Number,
    scale: 5, // digits after point, 0 for integers
    signed: true, // disallow negative
    thousandsSeparator: ",", // any single char
    padFractionalZeros: true, // if true, then pads zeros at end to the length of scale
    normalizeZeros: false, // appends or removes zeros at ends
    radix: ".", // fractional delimiter
    min: 0,
  };

  const [isExported, setExported] = useState(false);
  const [isImported, setImported] = useState(false);
  const [retry, setRetry] = useState(0);
  const [endorsmentType, setEndorsmentType] = useState("");
  const [quotationOperationId, setQuotationOperationId] = useState(null);
  const [summary, setSummary] = useState({});
  const [data, setData] = useState([]);
  const [maxLimit, setMaxLimit] = useState(null);
  const [masks, setMasks] = useState([]);
  const [isBound, setIsBound] = useState(false);
  const [operation, setOperation] = useState(null);

  const [sortBy, setSortBy] = useState({
    key: null,
    direction: null,
  });

  const [confirmed, setConfirmed] = useState({
    visible: false,
    title: "",
    icon: "times-circle",
    args: null,
  });

  const [facilities, setFacilities] = useState([]);
  const [updateNBIManually, setUpdateNBIManually] = useState(false);
  const [modalUnderwriter, setModalUnderwriter] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [insurerContacts, setInsurerContacts] = useState(null);
  const [selectedUnderwriters, setSelectedUnderwriters] = useState([]);
  const authContext = useContext(GlobalAuthContext);
  const loading = useContext(GlobalLoaderContext);
  const isClient = useMemo(() => authContext.enumProfile === 1, []);
  const [isUpdatedSchedule, setIsUpdatedSchedule] = useState(props?.path?.includes("market-composition-updated-schedule"));
  const [idOperationRedirect, setIdOperationRedirect] = useState(null);
  const [lloydsLeaders, setLloydsLeaders] = useState([]);
  const [insurersTaxes, setInsurersTaxes] = useState([]);

  const [questionnaire, setQuestionnaire] = useState([]);
  const [obligorGroup, setObligorGroup] = useState([]);
  const [insurerGroup, setInsurerGroup] = useState([]);
  const [feePayableByGroup, setFeePayableByGroup] = useState([]);
  const [lossPayeeGroup, setLossPayeeGroup] = useState([]);
  const [showBrokerRemunerationSection, setShowBrokerRemunerationSection] = useState(false);
  const [brokerRemunerationGroup, setBrokerRemunerationGroup] = useState([]);
  const [showBrokerRemunerationDeductionSection, setShowBrokerRemunerationDeductionSection] = useState(false);
  const [brokerRemunerationDeductionGroup, setBrokerRemunerationDeductionGroup] = useState([]);

  const [idProduct, setIdProduct] = useState(null);
  const [canGroup, setCanGroup] = useState(false);
  const [isGrouped, setIsGrouped] = useState(false);
  const [loadingTimeout, setLoadingTimeout] = useState(false);
  const [showThirdPartyPart, setShowThirdPartyPart] = useState(false);
  const [showSurplusBrokerPart, setShowSurplusBrokerPart] = useState(false);
  const [questionnaireAnswersToDelete, setQuestionnaireAnswersToDelete] = useState([]);
  const [isQuestionnaireLoaded, setIsQuestionnaireLoaded] = useState(false);

  const history = useHistory();
  const formik = useRef(Formik);
  const refQuestionnaireSent = useRef(false);

  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const columns = [
    {
      title: "Insurer",
      value: "nmInsurer",
      visible: true,
    },
    {
      title: "Legal Entity",
      value: "legalEntity",
      visible: true,
      maxWidth: 130,
      minWidth: 130
    },
    {
      title: "Premium Rate",
      value: "premiumRate",
      visible: true,
    },
    {
      title: "p.a.p.r Rate",
      value: "paprRate",
      visible: true,
    },
    {
      title: "Max Line Size",
      value: "maxLineSize",
      visible: true,
    },
    {
      title: "Line Size",
      value: "lineSize",
      visible: true,
    },
    {
      title: "Line Size %",
      value: "percLineSize",
      visible: true,
    },
    {
      title: "Brokerage",
      value: "brokerage",
      visible: true,
    },
    {
      title: "3rd. Party Part.",
      value: "thirdPartyParticipation",
      visible: showThirdPartyPart,
    },
    {
      title: "Surplus Broker Part.",
      value: "surplusBrokerParticipation",
      visible: showSurplusBrokerPart,
    },
    {
      title: "Surplus Brokerage",
      value: "surplusBrokeragePercent",
      visible: showSurplusBrokerPart,
    },
    {
      title: "Managed By",
      value: "idPersonManagedBy",
      visible: true,
      maxWidth: 130,
      minWidth: 130
    },
    {
      title: "",
      visible: true,
      maxWidth: 20,
      minWidth: 20
    },
  ];

  let SECTIONS = {
    OBLIGOR_PERC: { name: "OBLIGOR_PERC", isMultiple: true, isRisk: false },
    OBLIGOR_CONTRACT: { name: "OBLIGOR_CONTRACT", isMultiple: false, isRisk: false },
    TAX_RATES: { name: "TAX_RATES", isMultiple: false, isRisk: false },
    INSURER_TAXES: { name: "INSURER_TAXES", isMultiple: true, isRisk: false },
    FEE_PAYABLE_BY: { name: "FEE_PAYABLE_BY", isMultiple: true, isRisk: false },
    RISK_DETAILS: { name: "RISK_DETAILS", isMultiple: false, isRisk: false },
    RISK_DETAILS_FACILITY: { name: "RISK_DETAILS_FACILITY", isMultiple: false, isRisk: false },
    LOSS_PAYEE: { name: "LOSS_PAYEE", isMultiple: true, isRisk: false },
    INFORMATION: { name: "INFORMATION", isMultiple: false, isRisk: false },
    SECURITY_DETAILS: { name: "SECURITY_DETAILS", isMultiple: false, isRisk: false },
    PARTYS: { name: "PARTYS", isMultiple: false, isRisk: false },
    SUBSCRIPTON_AGREEMENT: { name: "SUBSCRIPTON_AGREEMENT", isMultiple: false, isRisk: false },
    FISCAL_AND_REGULATORY: { name: "FISCAL_AND_REGULATORY", isMultiple: false, isRisk: false },
    BROKER_REMUNERATION_FEE_CLIENT: { name: "BROKER_REMUNERATION_FEE_CLIENT", isMultiple: false, isRisk: false },
    BROKER_REMUNERATION: { name: "BROKER_REMUNERATION", isMultiple: true, isRisk: false },
    BROKER_REMUNERATION_OTHER: { name: "BROKER_REMUNERATION_OTHER", isMultiple: false, isRisk: false },
    BROKER_REMUNERATION_DEDUCTION: { name: "BROKER_REMUNERATION_DEDUCTION", isMultiple: true, isRisk: false },
    DECLARATION_TEMPLATE: { name: "DECLARATION_TEMPLATE", isMultiple: false, isRisk: false }
  };

  const endorsmentTypeEnum = {
    ["not-pre-agreed"]: {
      title: "Anniversary - Premium: Not Pre Agreed / Texel Core Data Record",
    },
    ["cancellation"]: {
      title: "Endorsement - Cancellation / Texel Core Data Record",
    },
    ["declaration"]: {
      title: "Endorsement - Declaration / Texel Core Data Record",
    },
    ["market-changes"]: {
      title: "Risk & Market Changes / Texel Core Data Record",
    },
  };

  const {
    loading: useHeaderNbiLoading,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    loading: useInsurerValuesLoading,
    request: useInsurerValuesRequest,
  } = useInsurerValues(props.match.params.idOperation);

  const {
    loading: useInsurerTaxesLoading,
    request: useInsurerTaxesRequest,
  } = useInsurerTaxes(props.match.params.idOperation);

  const {
    loading: useSaveInsurerTaxesLoading,
    request: useSaveInsurerTaxesRequest,
  } = useSaveInsurerTaxes(props.match.params.idOperation);

  const {
    loading: useListStampsContactsLoading,
    request: useListStampsContactsRequest,
  } = useListStampsContacts(props.match.params.idOperation);

  const {
    loading: useScheduleStatusLoading,
    request: useScheduleStatusRequest,
  } = useScheduleStatus(props.match.params.idOperation);

  const {
    loading: useInsurerLockLoading,
    request: useInsurerLockRequest,
  } = useInsurerLock();

  const {
    loading: useOperationInfoLoading,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  const {
    loading: useImportStatusLoading,
    request: useImportStatusRequest,
  } = useImportStatus(props.match.params.idOperation);

  const {
    loading: useCreateMarketChangeQuotationLoading,
    request: useCreateMarketChangeQuotationRequest,
  } = useCreateMarketChangeQuotation();

  const {
    loading: useUpdateNBIManuallyLoading,
    request: useUpdateNBIManuallyRequest,
  } = useUpdateNBIManually();

  const {
    loading: useEndorsementDocLoading,
    request: useEndorsementDocRequest,
  } = useEndorsementDoc(props.match.params.idOperation, endorsmentType);

  const {
    data: useGetQuestionnairesAnswersData,
    loading: useGetQuestionnairesAnswersLoading,
    status: useGetQuestionnairesAnswersStatus,
    request: useGetQuestionnairesAnswersRequest,
  } = useGetQuestionnaireAnswer(props.match.params.idOperation);

  const {
    loading: useGetOperationLoading,
  } = useGetOperationAsync(props.match.params.idOperation);

  const {
    loading: useSaveQuestionnaireAnswerLoading,
    request: useSaveQuestionnaireAnswerRequest,
  } = useSaveQuestionnaireAnswerSync(props.match.params.idOperation);

  const {
    status: useDeleteQuestionnaireAnswerStatus,
    loading: useDeleteQuestionnaireAnswerLoading,
    request: useDeleteQuestionnaireAnswerRequest,
  } = useDeleteQuestionnaireAnswer(props.match.params.idOperation);


  const {
    loading: useGenerateWordingLoading,
    request: useGenerateWordingRequest,
  } = useGenerateWording(props.match.params.idOperation);

  useEffect(() => {
    if (
      useInsurerValuesLoading ||
      useListStampsContactsLoading ||
      useHeaderNbiLoading ||
      useScheduleStatusLoading ||
      useInsurerLockLoading ||
      useOperationInfoLoading ||
      useImportStatusLoading ||
      useCreateMarketChangeQuotationLoading ||
      useUpdateNBIManuallyLoading ||
      useEndorsementDocLoading ||
      useInsurerTaxesLoading ||
      useSaveInsurerTaxesLoading ||
      useGetQuestionnairesAnswersLoading ||
      useGetOperationLoading ||
      useSaveQuestionnaireAnswerLoading ||
      useDeleteQuestionnaireAnswerLoading ||
      loadingTimeout ||
      useGenerateWordingLoading
    ) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [
    useInsurerValuesLoading,
    useListStampsContactsLoading,
    useHeaderNbiLoading,
    useScheduleStatusLoading,
    useInsurerLockLoading,
    useOperationInfoLoading,
    useImportStatusLoading,
    useCreateMarketChangeQuotationLoading,
    useUpdateNBIManuallyLoading,
    useEndorsementDocLoading,
    useInsurerTaxesLoading,
    useGetQuestionnairesAnswersLoading,
    useGetOperationLoading,
    useSaveQuestionnaireAnswerLoading,
    useDeleteQuestionnaireAnswerLoading,
    useSaveInsurerTaxesLoading,
    loadingTimeout,
    useGenerateWordingLoading
  ]);

  useEffect(() => {
    if (useGetQuestionnairesAnswersStatus === 200 && idProduct) {
      handleQuestionnaire(useGetQuestionnairesAnswersData?.value);
    }
  }, [useGetQuestionnairesAnswersStatus, useOperationInfoStatus, operation]);

  useEffect(() => {
    if (useDeleteQuestionnaireAnswerStatus === 200) {
      useGetQuestionnairesAnswersRequest();
    }
  }, [useDeleteQuestionnaireAnswerStatus]);

  function getLloydsAndSlipLeaders() {
    useInsurerValuesRequest().then(({ data: res }) => {
      if (res.ret_code !== 200) {
        mc.error(res.ret_msg_details);
        loading.stop();
        return;
      }

      setLloydsLeaders(res.ret_value.lloydsLeaders.listLloydsLeaders);

      useGetQuestionnairesAnswersRequest();
    });
  }

  function getGridItems() {
    useInsurerValuesRequest().then(({ data: res }) => {
      if (res.ret_code !== 200) {
        mc.error(res.ret_msg_details);
        return;
      }

      const GET_PREMIUM_RATE = {
        price_on_exposure: {
          premium_rate: (value) =>
            `${maskHelper.resolveMask(
              value.premiumRate,
              maskHelper.getPercentage(authContext.region, 5, "100.00", "0", true), /% (\d+\.\d+)/, "$1 %")} p.a.p.r`,
          premium_rate_as_gross_margin: (value) =>
            `${maskHelper.resolveMask(
              value.premiumRateAsPercentGrossMargin * 100,
              maskHelper.getPercentage(authContext.region, 5, "100.00", "0", true), /% (\d+\.\d+)/, "$1 %")} of Gross Margin`,
          premium_rate_as_net_margin: (value) =>
            `${maskHelper.resolveMask(
              value.premiumRateAsPercentGrossMargin * 100,
              maskHelper.getPercentage(authContext.region, 5, "100.00", "0", true), /% (\d+\.\d+)/, "$1 %")} as Net Margin`,
          estimated_insured_earnings_percent: (value) =>
            `${maskHelper.resolveMask(
              value.premiumRate,
              maskHelper.getPercentage(authContext.region, 5, "100.00", "0", true), /% (\d+\.\d+)/, "$1 %")} Estimated Insured Earnings`,
        },
        price_on_limit: {
          premium_rate: (value) =>
            `${maskHelper.resolveMask(value.premiumRate, maskHelper.getPercentage(authContext.region, 5, "100.00", "0", true), /% (\d+\.\d+)/, "$1 %")} p.a.p.r`,
          flat_premium_rate: (value) => `USD ${format(value.flatPremiumRate, true)} Flat Premium`,
        },
      };


      const getPremiumRate = (item) => {
        try {
          if (GET_PREMIUM_RATE[item.nbiRequestInsurerResponse.priceTypeByFacility]) {
            return GET_PREMIUM_RATE[item.nbiRequestInsurerResponse.priceTypeByFacility][
              item.nbiRequestInsurerResponse.premiumRateTypeByFacility
            ](item.nbiRequestInsurerResponse)
          } else {
            return GET_PREMIUM_RATE["price_on_exposure"][
              item.nbiRequestInsurerResponse.premiumRateTypeByFacility
            ](item.nbiRequestInsurerResponse)
          }
        } catch (e) {
          return "-"
        }
      }


      let d = res.ret_value.facilities.map((facility) => {
        facility.insurers = facility.insurers
          .map((item) => ({
            idPersonInsurer: item.idPersonInsurer,
            nmInsurer: item.nmInsurer,
            maxLineSize: item.nbiRequestInsurerResponse.maxLineSize,
            premiumRate: getPremiumRate(item),
            paprRate: item.premiumRate || item.nbiRequestInsurerResponse.premiumRate,
            lineSize: !isNaN(Number(item.lineSize)) ? item.lineSize : item.nbiRequestInsurerResponse.lineSize,
            percLineSize: !isNaN(Number(item.percLineSize)) ? item.percLineSize : item.nbiRequestInsurerResponse.percLineSize,
            brokerage: item.brokerage || item.nbiRequestInsurerResponse.brokerage,
            thirdPartyParticipation: item.thirdPartyParticipation || item.nbiRequestInsurerResponse.thirdPartyParticipation,
            surplusBrokerParticipation: item.surplusBrokerParticipation || item.nbiRequestInsurerResponse.surplusBrokerParticipation,
            surplusBrokeragePercent: item.surplusBrokeragePercent || item.nbiRequestInsurerResponse.surplusBrokeragePercent,
            personInsurerLegalEntity: item.personInsurerLegalEntity,
            nbiRequestInsurerResponse: item.nbiRequestInsurerResponse,
            idPersonManagedBy: item.idPersonManagedBy,
          }))
          .sort((a, b) => String(a?.nmInsurer).localeCompare(String(b?.nmInsurer)));

        return facility;
      });

      setQuotationOperationId(res.ret_value.quotationOperationId);
      setData(d);

      formik.current?.setFieldValue("totalBrokerage", res.ret_value.totalBrokerage);
      formik.current?.setFieldValue("totalThirdPartyParticipation", res.ret_value.totalThirdPartyParticipation);
      formik.current?.setFieldValue("totalSurplusBrokerParticipation", res.ret_value.totalSurplusBrokerParticipation);

      if ("bolSaveLineSize" in res.ret_value) {
        if (formik.current) {
          formik.current?.setFieldValue("lock", res.ret_value.bolSaveLineSize);
        }
      }
    });
  }

  const getMasks = async () => {
    const t = await maskHelper.getMaskConfigs([69, 70], 295, authContext.token);
    setMasks(t);
  };

  function listContacts() {
    useListStampsContactsRequest(null, { forcePersonRolesContacts: true })
      .then(({ data }) => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }

        setContacts(data.ret_value.contacts);
      })
      .catch((error) => {
        mc.error("There was an error while fetching your data:  \n" + error);
        console.error("fitPostListContact - Error:", error);
      });
  }

  function handleSummary() {
    useHeaderNbiRequest({ idOperation: props.match.params.idOperation }, null)
      .then(({ data }) => {
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          currency: data.ret_value.currency,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });

        setEndorsmentType(data.ret_value.endorsmentType);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
        console.error("fitPostSummary - Error:", error);
      });
  }

  const getScheduleStatus = async () => {
    useScheduleStatusRequest()
      .then(({ data }) => {
        switch (data.ret_value.render.showButton) {
          case "IMPORT SCHEDULE":
            setExported(true);
            break;
          case "EXPORT SCHEDULE":
            setExported(false);
            break;
          case "GENERATE WORDING":
            setExported(true);
            setImported(true);
            break;
          case "CONFIRM SCHEDULE":
            setExported(true);
            break;
          default:
            setExported(false);
            break;
        }
      })
      .catch((error) => {
        mc.error("Erro executando consulta do status\n" + error);
      });
  };

  async function handleQuestionnaire(data) {
    setQuestionnaire([]);
    setObligorGroup([]);
    setLossPayeeGroup([]);
    setBrokerRemunerationGroup([]);
    setBrokerRemunerationDeductionGroup([]);
    setInsurerGroup([]);
    setFeePayableByGroup([]);
    
    setLoadingTimeout(true);
    await new Promise(resolve => setTimeout(() => {
      resolve();
    }, 500));

    setTimeout(() => {
      setLoadingTimeout(false);
    }, 800)

    let questionnaireAux = [
      ...data.persons,
      ...data.operations,
      ...data.payments,
      ...data.risks,
      ...data.mrc
    ];

    if (questionnaireAux && questionnaireAux.length > 0) {
      questionnaireAux = questionnaireAux.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);

      let obligorGroupQuestions = GeneralSection.events.groupMultipleFieldQuestions({
        mainIdQuestion: 759,
        questionnaire: questionnaireAux,
        handleQuestionsInitialAdjustments: null,
      });

      obligorGroupQuestions = obligorGroupQuestions.map((group) => ObligorPercSection.events.handleInitialAdjustments({
        questionnaire: group,
        isMAS,
        isNewYork,
      }))

      setObligorGroup(ObligorPercSection.events.handleSelectedObligorCodings({
        updatedObligorGroup: obligorGroupQuestions,
      }));

      ObligorPercSection.events.handleObligorCodingTotal({
        obligorGroup: obligorGroupQuestions,
        setFieldValue: formik.current?.setFieldValue,
        setFieldError: formik.current?.setFieldError,
        mc,
      })

      // RISK_DETAILS_FACILITY - Initial adjustments
      questionnaireAux = RiskDetailsFacilitySection.events.handleInitialAdjustments({
        questionnaire: questionnaireAux,
      });

      // RISK_DETAILS - Initial adjustments
      questionnaireAux = RiskDetailsSection.events.handleInitialAdjustments({
        questionnaire: questionnaireAux,
        idProduct,
      });

      // LOSS_PAYEE - Initial adjustments
      setLossPayeeGroup(GeneralSection.events.groupMultipleFieldQuestions({
        mainIdQuestion: 1466,
        questionnaire: questionnaireAux,
        handleQuestionsInitialAdjustments: LossPayeeSection.events.handleInitialAdjustments
      }));

      // INFORMATION - Initial adjustments
      questionnaireAux = InformationSection.events.handleInitialAdjustments({
        questionnaire: questionnaireAux,
      });

      // SECURITY_DETAILS - Initial adjustments
      questionnaireAux = SecurityDetailsSection.events.handleInitialAdjustments({
        questionnaire: questionnaireAux,
        lloydsLeaders,
      });

      // PARTYS - Initial adjustments
      questionnaireAux = PartysSection.events.handleInitialAdjustments({
        questionnaire: questionnaireAux,
      });

      // SUBSCRIPTION_AGREEMENT - Initial adjustments
      questionnaireAux = SubscriptionAgreementSection.events.handleInitialAdjustments({
        questionnaire: questionnaireAux,
      });

      // FISCAL_AND_REGULATORY - Initial adjustments
      questionnaireAux = FiscalAndRegulatorySection.events.handleInitialAdjustments({
        questionnaire: questionnaireAux,
      });

      // BROKER_REMUNERATION_FEE_CLIENT - Initial adjustments
      questionnaireAux = BrokerRemunerationFeeClientSection.events.handleInitialAdjustments({
        questionnaire: questionnaireAux,
        setShowBrokerRemunerationSection
      });

      // BROKER_REMUNERATION - Initial adjustments
      setBrokerRemunerationGroup(GeneralSection.events.groupMultipleFieldQuestions({
        mainIdQuestion: 1438,
        questionnaire: questionnaireAux,
        handleQuestionsInitialAdjustments: BrokerRemunerationSection.events.handleInitialAdjustments
      }));

      // BROKER_REMUNERATION_OTHER - Initial adjustments
      questionnaireAux = BrokerRemunerationOtherSection.events.handleInitialAdjustments({
        questionnaire: questionnaireAux,
        setShowBrokerRemunerationDeductionSection
      });

      // BROKER_REMUNERATION_DEDUCTION - Initial adjustments
      setBrokerRemunerationDeductionGroup(GeneralSection.events.groupMultipleFieldQuestions({
        mainIdQuestion: 1444,
        questionnaire: questionnaireAux,
        handleQuestionsInitialAdjustments: BrokerRemunerationDeductionSection.events.handleInitialAdjustments
      }));

      setQuestionnaire(JSON.parse(JSON.stringify(questionnaireAux)));
      setTimeout(() => setIsQuestionnaireLoaded(true), 300)
    }
  };

  const handleReset = () => {
    setExported(false);
    setImported(false);
  };

  function handleConfirmReset(a) {
    setConfirmed({
      visible: true,
      title: "CONFIRM RESET?",
      icon: "TimesCircle",
      args: a,
    });
  }

  const handleLock = (a, values) => {
    try {
      if (a) {
        let body = {
          idOperation: parseInt(props.match.params.idOperation),
          bolSaveLineSize: true,
          facilities: values.facilities.map((facility) => {
            facility.insurers = facility.insurers.map((item) => {
              let it = {
                idPersonInsurer: item.idPersonInsurer,
                lineSize: item.lineSize,
                percLineSize: item.percLineSize,
                brokerage: item.brokerage,
                thirdPartyParticipation: item.thirdPartyParticipation,
                surplusBrokerParticipation: item.surplusBrokerParticipation,
                surplusBrokeragePercent: item.surplusBrokeragePercent,
                idPersonLegalEntity: item.idPersonLegalEntity,
                nbiRequestInsurerResponse: item.nbiRequestInsurerResponse,
                idPersonManagedBy: item.idPersonManagedBy,
              };
              return it;
            });

            return facility;
          }),
        };

        useInsurerLockRequest({ ...body }, null)
          .then(({ data: res }) => {
            if (res.ret_code !== 200) {
              mc.error(res.ret_msg_details);
              return;
            }

            if (formik.current) {
              formik.current?.setFieldValue("lock", a);
            }

            getGridItems();
            getMasks();
            getScheduleStatus();
            useGetQuestionnairesAnswersRequest();
          })
          .catch((e) => {
            mc.error(e.message);
            return;
          });
      } else {
        handleConfirmReset(a);
      }
    } catch { }
  };

  function getLnSizeTotalByFacility(facility, facilityIndex) {
    let soma = 0;
    let somaLabel = 0;
    facility.insurers.map((item) => {
      if (!item.lineSize) {
        return;
      }

      soma = soma + parseFloat(item.lineSize);
      if (typeof item.lineSize === "number") {
        somaLabel = somaLabel + parseFloat(item.lineSize);
      } else {
        somaLabel = somaLabel + parseFloat(unformat(item.lineSize));
      }
    });

    if (formik.current) {
      formik.current?.setFieldValue(`facilities.${facilityIndex}.lineSizeTotal`, somaLabel);
    }

    return somaLabel;
  }

  function getMaxLnSizeTotalByFacility(facility, facilityIndex) {
    let soma = 0;
    let somaLabel = 0;
    facility.insurers.map((item) => {
      if (!item.maxLineSize) {
        return;
      }

      soma = soma + parseFloat(item.maxLineSize);
      if (typeof item.maxLineSize === "number") {
        somaLabel = somaLabel + parseFloat(item.maxLineSize);
      } else {
        somaLabel = somaLabel + parseFloat(unformat(item.maxLineSize));
      }
    });

    if (formik.current) {
      formik.current?.setFieldValue(`facilities.${facilityIndex}.maxLineSizeTotal`, somaLabel);
    }

    return somaLabel;
  }

  async function getLnSizeByFacility() {
    formik.current.values.facilities.forEach(async (facility, indexFacility) => {
      await getMaxLnSizeTotalByFacility(facility, indexFacility);
      let total = await getLnSizeTotalByFacility(facility, indexFacility);

      let lnSizeTotal = 0;
      facility.insurers.forEach((insurer, indexInsurer) => {
        let percLnSize;
        if (!insurer.lineSize) {
          if (formik.current) {
            formik.current?.setFieldValue(`facilities.${indexFacility}.insurers.${indexInsurer}.lineSize`, 0);
          }
          return;
        }
        let lineSizeConversion;
        if (typeof insurer.lineSize === "number") {
          lineSizeConversion = parseFloat(insurer.lineSize);
        } else {
          lineSizeConversion = parseFloat(unformat(insurer.lineSize.toString()));
        }

        percLnSize = total ? (lineSizeConversion / total) * 100 : 0;
        lnSizeTotal = lnSizeTotal + percLnSize;

        if (formik.current) {
          formik.current?.setFieldValue(`facilities.${indexFacility}.insurers.${indexInsurer}.percLineSize`, percLnSize);
        }

        if (formik.current && insurer.personInsurerLegalEntity) {
          formik.current?.setFieldValue(
            `facilities.${indexFacility}.insurers.${indexInsurer}.idPersonLegalEntity`,
            insurer.personInsurerLegalEntity.idPersonTail
          );
        }

        if (formik.current && insurer.idPersonManagedBy) {
          formik.current?.setFieldValue(
            `facilities.${indexFacility}.insurers.${indexInsurer}.idPersonManagedBy`,
            insurer.idPersonManagedBy
          );
        }
      });

      if (formik.current) {
        formik.current?.setFieldValue(`facilities.${indexFacility}.percLnSizeTotal`, lnSizeTotal);
      }
    });
  }

  function formatMaxLimit(value) {
    let mask = maskHelper.getMaskConfig(masks, 69, authContext.region);
    if (mask) {
      mask.padFractionalZeros = true;
      return maskHelper.resolveMask(value, mask);
    }
  }

  function unformat(value) {
    if (typeof value === "number") {
      return;
    }
    let maskCurrency = IMask.createMask(mask);
    maskCurrency.resolve(value);
    var valueUnformated = maskCurrency.unmaskedValue;
    return valueUnformated;
  }

  function format(value, bb) {
    let maskCurrency = IMask.createMask(mask);
    let formated = maskCurrency.resolve(value ? value.toString() : "0");
    return formated;
  }

  const renderOptionsNbiResponseList = (NbiResponseList) => {
    let result = [],
      entities = [];

    if (NbiResponseList.hasOwnProperty("selectedLegalEntities")) {
      entities = NbiResponseList.selectedLegalEntities;
    } else {
      entities = NbiResponseList.legalEntities;
    }

    entities.forEach((element) => {
      result.push({
        label: element.insured_legal_entity,
        value: element.idPersonLegalEntity,
      });
    });

    return result;
  };

  const createValidation = () => {
    let validationFacility = {};
    let validationSchema = {};
    let validationInsurer = {};

    for (let f = 0; f < facilities.length; f++) {
      for (let i = 0; i < facilities[f].insurers.length; i++) {
        validationInsurer[`idPersonLegalEntity`] = yup.string().required("* Required field");
      }
    }

    validationFacility.insurers = yup
      .array()
      .of(yup.object().shape(validationInsurer))
      .test({
        name: "first-and-last",
        message: "* Required field",
        test: (val) => {
          return val.every(({ idPersonLegalEntity, idPersonManagedBy }, index) => {
            return (!!idPersonLegalEntity && !!idPersonManagedBy);
          })
        },
      });

    validationSchema.facilities = yup.array().of(yup.object().shape(validationFacility));
    return validationSchema;
  };

  const buildValidation = (questionnaireSaved, taxesAndCoverages = false) => {
    try {
      const validationSchema = {};
      let validationSchemaOld = {};

      if (taxesAndCoverages) {
        const questionnaire = questionnaireSaved
          ? handleSaveQuestionnaireAnswer(questionnaireSaved)
          : handleSaveQuestionnaireAnswer(formik?.current?.values);

        for (const question of questionnaire || []) {
          if (question.idQuestion == 759) {
            validationSchema[question.key] = yup.object().required("* Required field");
          } else if (question.idQuestion == 760 && !question.disabled) {
            validationSchema[question.key] = yup.string().required("* Required field");
          } else {
            validationSchema[question.key] =
              question.visibleQuestion && question.behaviorObject?.isRequired
                ? yup.string().test("answer-validation", "Required Field", function (value) {
                  return !!question.answer;
                })
                : yup.string().notRequired();
          }
        }
      } else {
        validationSchemaOld = createValidation();
      }

      let validationSchemaFinal = { ...validationSchema, ...validationSchemaOld };

      //setValidation(yup.object().shape(validationSchemaFinal));

      return yup.object().shape(validationSchemaFinal);
    } catch (e) { }
  };

  const renderFlowClient = (formikProps) => {
    if (isClient) return <></>;

    return (
      <>
        <HasPermission permission={props.permissions.MARKETS_SELECTION}>
          <Button
            third
            style={{ marginLeft: "10px", marginTop: "5px" }}
            onClick={(e) => {
              history.push(`/broking/market-selection/${quotationOperationId || props.match.params.idOperation}`, {
                idOperation: props.match?.params?.idOperation || null,
                idProduct: props.location?.state?.idProduct || null,
              });
            }}
          >
            UPDATE NBI
          </Button>
        </HasPermission>
      </>
    );
  };

  const handleCreateMarketChangeQuotation = () => {
    useCreateMarketChangeQuotationRequest({ idOperation: props.match.params.idOperation }, null)
      .then(({ data: resp }) => {
        if (resp.ret_code !== 200) {
          mc.error(resp.ret_msg_details);
          return;
        }

        history.push(`/broking/market-selection/${resp?.ret_value.quotationOperationId || props.match?.params?.idOperation}`, {
          idOperation: props.match?.params?.idOperation || null,
          idProduct: props.location?.state?.idProduct || null,
        });
      })
      .catch((e) => { });
  };

  const handleContactsForNBIUpdate = (item) => {
    const insurerFiltered = [...contacts.filter((insurer) => insurer.idPersonRoot === item.idPersonInsurer)];

    const insurer = {
      idPersonInsurer: item.idPersonInsurer,
      contacts: insurerFiltered[0].contacts,
      insurerFirstName: insurerFiltered[0].insurerFirstName,
    };

    setInsurerContacts(insurer);
    setModalUnderwriter(true);
  };

  const handleUpdateNBIManually = (insurer, underwriters) => {
    const idOperation = props.match.params.idOperation;

    if (!underwriters.length) {
      mc.error("Select at least one underwriter");
      return;
    }

    useUpdateNBIManuallyRequest({ idOperation: idOperation, insurer: insurer, underwriters: underwriters }, null).then(({ data }) => {
      if (data.ret_code !== 200) {
        mc.error(data.ret_msg_details);
        return;
      }

      setSelectedUnderwriters([]);
      window.open(data.ret_value, "_blank");
    });
  };

  useEffect(() => {
    if (retry > 0 && retry < 21) {
      useImportStatusRequest()
        .then(({ data: res }) => {
          if (res.ret_code !== 200) {
            mc.error(res.ret_msg_details, true);
            setRetry(0);
            return;
          }

          let idOperationRediret = isUpdatedSchedule ? idOperationRedirect : props.match.params.idOperation;
          if (res.ret_value.idDomainStatus) {
            if (res.ret_value.idDomainStatus === 35) {
              if (isUpdatedSchedule) {
                history.push(`/broking/schedule-exibition-updated-schedule/${idOperationRediret}`, {
                  idOperation: props.match?.params?.idOperation || null,
                  idProduct: props.location?.state?.idProduct || null,
                });
              } else {
                history.push(`/broking/schedule-exibition/${idOperationRediret}`, {
                  idOperation: props.match?.params?.idOperation || null,
                  idProduct: props.location?.state?.idProduct || null,
                });
              }
              setRetry(0);
            } else if (res.ret_value.idDomainStatus === 36) {
              if (res.ret_value.errorsImportSchedulle) {
                res.ret_value.errorsImportSchedulle.forEach((i) => {
                  if (i.ret_msg_details) {
                    mc.error(i.ret_msg_details);
                  }
                });
              }
              setRetry(0);
            } else {
              setTimeout(() => setRetry(retry + 1), 750);
            }
          }
        })
        .catch(() => {
          setRetry(0);
        });
    } else if (retry === 21) {
      mc.error("Import Timeout");
      setRetry(0);
    } else if (retry === 0) {
    }
  }, [retry]);

  useEffect(() => {
    let mask = maskHelper.getMaskConfig(masks, 69, authContext.region);
    if (mask) {
      mask.padFractionalZeros = true;
    }
  }, [maxLimit, masks]);

  useEffect(() => {
    if (formik.current) {
      formik.current?.setFieldValue("facilities", data);
    }

    setTimeout(function () {
      if (formik?.current?.values?.facilities) {
        getLnSizeByFacility();
      }
    }, 1500);
  }, [data]);

  function generateContract() {
    useSaveInsurerTaxesRequest().then(() => {
      setExported(false);
      setImported(false);
      getScheduleStatus();
    });

    let route = null;
    if (endorsmentType === 'market-changes') route = 'risk-and-market-changes-edit';
    if (endorsmentType === 'not-pre-agreed') route = 'not-pre-agreed-edit';
    if (endorsmentType === 'cancellation') route = 'cancellation-edit';

    if (endorsmentType && route) return history.push(`/broking/${route}/${props.match.params.idOperation}`);

    if (endorsmentType === "declaration") {
      useGenerateWordingRequest().then(({ data }) => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details)
        }

        history.push(`/broking/contract-builder/${props.match.params.idOperation}`);
      })
    } else if (!endorsmentType) {
      history.push(`/broking/contract-builder/${props.match.params.idOperation}`);
    }
  }

  const handleOperationInfo = () => {
    useOperationInfoRequest(null, { loadPersonRoles: true }).then(({ data }) => {
      setIdProduct(data.idProduct);
      setIsBound(data.isBound || false);
      setOperation(data);
      setUpdateNBIManually(data.updateNBIManually || false);
      setIsNewYork(data.isNewYork);
      setIsMAS(data.isMas);
      setShowThirdPartyPart(!!data.personRoles?.find((x) => x.ID_DOMAIN == 11));
      setShowSurplusBrokerPart(!!data.personRoles?.find((x) => x.ID_DOMAIN == 9));
    });
  };

  function handleSelectUnderwriter(contact) {
    const select = {
      name: contact.nameContact,
      email: contact.email,
      idContact: contact.idContact,
    };

    const alreadySelected = selectedUnderwriters.find((item) => item.idContact === select.idContact);

    if (alreadySelected) {
      const signers = selectedUnderwriters.filter((item) => item.idContact !== select.idContact);
      setSelectedUnderwriters(signers);
    } else {
      setSelectedUnderwriters([select, ...selectedUnderwriters]);
    }
  }

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);
    handleOperationInfo();
    getGridItems();
    getMasks();
    handleSummary();
    listContacts();
    getScheduleStatus();
    getLloydsAndSlipLeaders();
  }, []);

  const handleSaveQuestionnaireAnswer = (values) => {
    const questionnaireAnswers = [];

    for (const [key, section] of Object.entries(SECTIONS)) {
      if (section.isMultiple) {
        let multipleFields = Object.entries(values)
          .filter((prop) => new RegExp(`[^.]*(${section.name}_)(\\d)`).test(prop[0]))
          .flatMap((fields) => fields.at(-1));

        if (multipleFields) {
          questionnaireAnswers.push(...multipleFields);
        }
      } else {
        let sectionAnswers = values[`$ANSWERS_${section.name}`];

        if (sectionAnswers) {
          questionnaireAnswers.push(...sectionAnswers);
        }
      }
    }

    questionnaireAnswers.forEach((question) => {
      if (typeof question.answer !== "string") question.answer = JSON.stringify(question.answer);
      if (typeof question.answerJson !== "string") question.answerJson = JSON.stringify(question.answerJson);
    });

    return questionnaireAnswers;
  };

  return (
    <Layout idOperation={props.match?.params?.idOperation} title={summary.nmObligor || "Broking name"} subtitle={summary.dealCode || "Deal Code"}>
      <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />
      <BrokingSummary data={summary} />

      <ContentCard
        icon
        title={endorsmentTypeEnum[endorsmentType] ? endorsmentTypeEnum[endorsmentType].title : "Texel Core Data Record"}
        info={{
          idOperation: props.match?.params?.idOperation || null,
          idProduct: props.location?.state?.idProduct || null,
        }}
      >
        <DialogComponent icon={confirmed.icon} title={confirmed.title} show={confirmed.visible} setDialog={setConfirmed}>
          <Styled.DialogCancel
            onClick={() => {
              setConfirmed({ visible: false, title: null, icon: null, args: null });
            }}
          >
            Cancel
          </Styled.DialogCancel>
          <Styled.DialogConfirm
            onClick={() => {
              setConfirmed({ visible: false, title: null, icon: null, args: null });
              formik.current?.setFieldValue("lock", confirmed.args);
              handleReset();

              setQuestionnaire([]);
              setObligorGroup([]);
              setLossPayeeGroup([]);
              setBrokerRemunerationGroup([]);
              setBrokerRemunerationDeductionGroup([]);
              setInsurerGroup([]);
              setFeePayableByGroup([]);
            }}
          >
            Confirm
          </Styled.DialogConfirm>
        </DialogComponent>

        <Formik
          initialValues={{
            lock: false,
            lockCoverageTaxes: "No",
            insurers: [],
            facilities: [],
            attachments: [],
            documentType: [],
            obligorCoding: "",
            obligorCodingPercentage: "100",
            obligorCodingTotal: "100",
          }}
          innerRef={formik}
          enableReinitialize={true}
          validateOnChange={false}
          validateOnBlur={false}
          render={(formikProps) => (
            <Form key="mkt-composition-form">
              <Styled.ScrollBox>
                {formikProps.values.facilities.map((facility, facilityIndex) => (
                  <>
                    <Row style={{ display: "flex", paddingBottom: "15px", justifyContent: "center", alignItems: "center" }}>
                      <Col>
                        <Styled.Text fontSize={16} secundary>
                          {facility.name ? facility.name : "MAIN CONTRACT"} - REQUESTED LIMIT OF LIABILITY {facility.facility_currency || ""}{" "}
                          {formatMaxLimit(facility.max_limit_of_liability)}
                        </Styled.Text>
                      </Col>
                    </Row>

                    <div style={{ marginLeft: 15, marginRight: 15, marginBottom: 100 }}>
                      <Styled.Table
                        style={{ tableLayout: 'fixed' }}
                      >
                        <Styled.TableHead>
                          <Styled.TableRow>
                            {columns
                              .filter((x) => x.visible)
                              .map((column, index) => (

                                <Styled.TableHeader
                                  key={index}
                                  minWidth={column.minWidth}
                                  maxWidth={column.maxWidth}
                                >
                                  <Styled.Text style={{ margin: "0 auto", textTransform: "uppercase" }}>
                                    {column.title === "Brokerage" && isClient ? "" : column.title}
                                  </Styled.Text>
                                  {column.value && sortBy.key === column.value && sortBy.direction === "asc" ? (
                                    <Icon name={"arrowup"} />
                                  ) : column.value && sortBy.key === column.value && sortBy.direction === "desc" ? (
                                    <Icon name={"arrowdown"} />
                                  ) : (
                                    ""
                                  )}
                                </Styled.TableHeader>
                              ))}
                          </Styled.TableRow>
                        </Styled.TableHead>

                        <Styled.TableBody>
                          <FieldArray
                            name="insurers"
                            render={() =>
                              facility.insurers.map((item, index) => (
                                <Styled.TableRow key={index}>
                                  <Styled.TableColumn>
                                    <Styled.InlineLabel>Insurer</Styled.InlineLabel>
                                    <Styled.Text style={{ fontWeight: "bold" }}>{item.nmInsurer}</Styled.Text>
                                  </Styled.TableColumn>

                                  <Styled.TableColumn style={{ width: 250 }}>
                                    <Styled.InlineLabel>Legal Entity</Styled.InlineLabel>
                                    <Field
                                      name={`facilities.${facilityIndex}.insurers.${index}.idPersonLegalEntity`}
                                      component={ComboBox}
                                      options={renderOptionsNbiResponseList(item.nbiRequestInsurerResponse)}
                                      value={formikProps.values.facilities[facilityIndex].insurers[index].idPersonLegalEntity}
                                      onChange={(e) => {
                                        formik.current?.setFieldValue(`facilities.${facilityIndex}.insurers.${index}.idPersonLegalEntity`, e);
                                      }}
                                      disabled={formikProps.values.lock || isBound || isClient}
                                      topReduce
                                      style={{
                                        width: "120px",
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                        color: "gray",
                                      }}
                                      isRequired
                                    />
                                  </Styled.TableColumn>

                                  <Styled.TableColumn>
                                    <Styled.InlineLabel>Premium Rate</Styled.InlineLabel>
                                    <Styled.Text style={{ fontWeight: "bold" }}>{item?.premiumRate}</Styled.Text>
                                  </Styled.TableColumn>

                                  <Styled.TableColumn>
                                    <Styled.InlineLabel>p.a.p.r Rate</Styled.InlineLabel>
                                    <Styled.Text style={{ wordBreak: 'break-all', fontWeight: "bold" }}>
                                      {maskHelper.resolveMask(
                                        item?.paprRate,
                                        maskHelper.getPercentage(authContext.region, 5, "100.00", "0", true),
                                        /% (\d+\.\d+)/,
                                        "$1 %"
                                      )}
                                    </Styled.Text>
                                  </Styled.TableColumn>

                                  <Styled.TableColumn>
                                    <Styled.InlineLabel>Max Line Size</Styled.InlineLabel>
                                    <Styled.Text style={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
                                      {maskHelper.resolveMask(
                                        item?.maxLineSize,
                                        maskHelper.getMaskConfig(masks, 69, authContext.region, facility.max_limit_of_liability || null, true)
                                      )}
                                    </Styled.Text>
                                  </Styled.TableColumn>

                                  <Styled.TableColumn>
                                    <Styled.InlineLabel>Line Size</Styled.InlineLabel>
                                    {formikProps.values.lock || isClient ? (
                                      <Styled.Text style={{ whiteSpace: "nowrap" }}>
                                        {format(formikProps.values.facilities[facilityIndex].insurers[index].lineSize, true)}
                                      </Styled.Text>
                                    ) : (
                                      <Field
                                        disabled={formikProps.values.lock || isBound}
                                        name={`facilities.${facilityIndex}.insurers.${index}.lineSize`}
                                        value={format(formikProps.values.facilities[facilityIndex].insurers[index].lineSize, true)}
                                        mask={maskHelper.getMask("currency", authContext.region, 2, 12, item?.maxLineSize, 0)}
                                        onChange={(e) => {
                                          if (item?.maxLineSize < e) {
                                            formikProps?.setFieldValue(`facilities.${facilityIndex}.insurers.${index}.lineSize`, item?.maxLineSize);
                                          } else {
                                            formikProps?.setFieldValue(`facilities.${facilityIndex}.insurers.${index}.lineSize`, e);
                                          }
                                        }}
                                        component={InputField}
                                        onBlur={() => {
                                          getLnSizeByFacility();
                                        }}
                                        validation={false}
                                        style={{ width: "100px", cursor: "pointer", fontWeight: "bold", color: "gray" }}
                                      />
                                    )}
                                  </Styled.TableColumn>

                                  <Styled.TableColumn>
                                    <Styled.InlineLabel>Line Size %</Styled.InlineLabel>
                                    <Styled.Text style={{ wordBreak: 'break-all', fontWeight: "bold" }}>
                                      {maskHelper.resolveMask(
                                        item?.percLineSize || 0,
                                        maskHelper.getPercentage(authContext.region, 5, "100.00", "0", true),
                                        /% (\d+\.\d+)/,
                                        "$1 %"
                                      )}
                                    </Styled.Text>
                                  </Styled.TableColumn>

                                  {!isClient ? (
                                    <Styled.TableColumn width={150}>
                                      <Styled.InlineLabel>Brokerage</Styled.InlineLabel>
                                      {formikProps.values.lock ? (
                                        <Styled.Text style={{ wordBreak: 'break-all', fontWeight: "bold" }}>
                                          {maskHelper.resolveMask(
                                            formikProps?.values?.facilities[facilityIndex]?.insurers[index]?.brokerage || 0,
                                            maskHelper.getPercentage(authContext.region, 5, "100.00", "0", true),
                                            /% (\d+\.\d+)/,
                                            "$1 %"
                                          )}
                                        </Styled.Text>
                                      ) : (
                                        <Field
                                          name={`facilities.${facilityIndex}.insurers.${index}.brokerage`}
                                          mask={maskHelper.getPercentage(authContext.region, 5, "100.00")}
                                          value={formikProps.values.facilities[facilityIndex].insurers[index].brokerage}
                                          component={InputField}
                                          validation={false}
                                          disabled={formikProps.values.lock || isBound}
                                        />
                                      )}
                                    </Styled.TableColumn>
                                  ) : (
                                    <Styled.TableColumn></Styled.TableColumn>
                                  )}

                                  {showThirdPartyPart && (
                                    <Styled.TableColumn width={150}>
                                      <Styled.InlineLabel>3rd. Party Part.</Styled.InlineLabel>
                                      {formikProps.values.lock ? (
                                        <Styled.Text style={{ wordBreak: 'break-all', fontWeight: "bold" }}>
                                          {maskHelper.resolveMask(
                                            formikProps.values.facilities[facilityIndex].insurers[index].thirdPartyParticipation || 0,
                                            maskHelper.getPercentage(authContext.region, 5, "100.00", "0", true),
                                            /% (\d+\.\d+)/,
                                            "$1 %"
                                          )}
                                        </Styled.Text>
                                      ) : (
                                        <Field
                                          name={`facilities.${facilityIndex}.insurers.${index}.thirdPartyParticipation`}
                                          mask={maskHelper.getPercentage(authContext.region, 5, "100.00")}
                                          value={formikProps.values.facilities[facilityIndex].insurers[index].thirdPartyParticipation}
                                          component={InputField}
                                          validation={false}
                                          disabled={formikProps.values.lock || !showThirdPartyPart}
                                          onChange={(e) => {
                                            formikProps?.setFieldValue(`facilities.${facilityIndex}.insurers.${index}.thirdPartyParticipation`, e);
                                          }}
                                        />
                                      )}
                                    </Styled.TableColumn>
                                  )}

                                  {showSurplusBrokerPart && (
                                    <>
                                      <Styled.TableColumn width={160}>
                                        <Styled.InlineLabel>Surplus Broker Part.</Styled.InlineLabel>
                                        {formikProps.values.lock ? (
                                          <Styled.Text style={{ wordBreak: 'break-all', fontWeight: "bold" }}>
                                            {maskHelper.resolveMask(
                                              formikProps.values.facilities[facilityIndex].insurers[index].surplusBrokerParticipation || 0,
                                              maskHelper.getPercentage(authContext.region, 5, "100.00", "0", true),
                                              /% (\d+\.\d+)/,
                                              "$1 %"
                                            )}
                                          </Styled.Text>
                                        ) : (
                                          <Field
                                            name={`facilities.${facilityIndex}.insurers.${index}.surplusBrokerParticipation`}
                                            mask={maskHelper.getPercentage(authContext.region, 5, "100.00")}
                                            value={formikProps.values.facilities[facilityIndex].insurers[index].surplusBrokerParticipation}
                                            component={InputField}
                                            validation={false}
                                            disabled={formikProps.values.lock || !showSurplusBrokerPart}
                                            onChange={(e) => {
                                              formikProps?.setFieldValue(`facilities.${facilityIndex}.insurers.${index}.surplusBrokerParticipation`, e);
                                            }}
                                          />
                                        )}
                                      </Styled.TableColumn>

                                      <Styled.TableColumn width={150}>
                                        <Styled.InlineLabel>Surplus Brokerage</Styled.InlineLabel>
                                        {formikProps.values.lock ? (
                                          <Styled.Text style={{ wordBreak: 'break-all', fontWeight: "bold" }}>
                                            {maskHelper.resolveMask(
                                              formikProps.values.facilities[facilityIndex].insurers[index].surplusBrokeragePercent || 0,
                                              maskHelper.getPercentage(authContext.region, 5, "100.00", "0", true),
                                              /% (\d+\.\d+)/,
                                              "$1 %"
                                            )}
                                          </Styled.Text>
                                        ) : (
                                          <Field
                                            name={`facilities.${facilityIndex}.insurers.${index}.surplusBrokeragePercent`}
                                            mask={maskHelper.getPercentage(authContext.region, 5, "100.00")}
                                            value={formikProps.values.facilities[facilityIndex].insurers[index].surplusBrokeragePercent}
                                            component={InputField}
                                            validation={false}
                                            disabled={formikProps.values.lock || !showSurplusBrokerPart}
                                            onChange={(e) => {
                                              formikProps?.setFieldValue(`facilities.${facilityIndex}.insurers.${index}.surplusBrokeragePercent`, e);
                                            }}
                                          />
                                        )}
                                      </Styled.TableColumn>
                                    </>
                                  )}

                                  <Styled.TableColumn style={{ width: 250 }}>
                                    <Styled.InlineLabel>Managed By</Styled.InlineLabel>
                                    <Field
                                      name={`facilities.${facilityIndex}.insurers.${index}.idPersonManagedBy`}
                                      component={ComboBox}
                                      options={GeneralSection.events.getManagedByOptions({ questionnaire })}
                                      defaultValue={questionnaire.find((x) => x.idQuestion === 124)?.idAnswerOption}
                                      value={formikProps.values.facilities[facilityIndex].insurers[index].idPersonManagedBy}
                                      onChange={(e) => {
                                        formik.current?.setFieldValue(`facilities.${facilityIndex}.insurers.${index}.idPersonManagedBy`, e);
                                      }}
                                      topReduce
                                      disabled={formikProps.values.lock || isBound || isClient}
                                      style={{
                                        width: "120px",
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                        color: "gray",
                                      }}
                                      isRequired
                                    />
                                  </Styled.TableColumn>

                                  <Styled.TableColumn width={30}>
                                    <Col>
                                      <Icon
                                        name={
                                          !formikProps.values.lock && (!endorsmentType || endorsmentType === "declaration") && updateNBIManually
                                            ? "edit-grey"
                                            : "edit-grey-disabled"
                                        }
                                        title={"Update NBI Request Manually"}
                                        onClick={() => {
                                          if (
                                            !formikProps.values.lock &&
                                            (!endorsmentType || endorsmentType === "declaration") &&
                                            updateNBIManually &&
                                            contacts.length
                                          )
                                            handleContactsForNBIUpdate(item);
                                        }}
                                        style={{
                                          cursor:
                                            !formikProps.values.lock && (!endorsmentType || endorsmentType === "declaration") && updateNBIManually
                                              ? "pointer"
                                              : "not-allowed",
                                        }}
                                      />
                                    </Col>
                                  </Styled.TableColumn>
                                </Styled.TableRow>
                              ))
                            }
                          />

                          <Styled.TableRow>
                            <Styled.TableColumn>
                              <Styled.Text secundary>TOTAL</Styled.Text>
                            </Styled.TableColumn>

                            <Styled.TableColumn>
                              <Styled.Text style={{ whiteSpace: "nowrap" }}> </Styled.Text>
                            </Styled.TableColumn>

                            <Styled.TableColumn
                              style={{ justifyContent: "center", alignItems: "center", paddingTop: "10px", paddingBottom: "5px", color: "black" }}
                            >
                              <Styled.Text style={{ whiteSpace: "nowrap" }}>{format(facility.maxLineSizeTotal)}</Styled.Text>
                            </Styled.TableColumn>

                            <Styled.TableColumn>
                              <Styled.Text style={{ whiteSpace: "nowrap" }}> </Styled.Text>
                            </Styled.TableColumn>

                            <Styled.TableColumn>
                              <Styled.Text style={{ whiteSpace: "nowrap" }}> </Styled.Text>
                            </Styled.TableColumn>

                            <Styled.TableColumn
                              style={{ justifyContent: "center", alignItems: "center", paddingTop: "10px", paddingBottom: "5px", color: "black" }}
                            >
                              <Styled.Text style={{ whiteSpace: "nowrap" }}>{format(facility.lineSizeTotal)}</Styled.Text>
                            </Styled.TableColumn>

                            <Styled.TableColumn
                              style={{ justifyContent: "center", alignItems: "center", paddingTop: "10px", paddingBottom: "5px", color: "black" }}
                            >
                              <Styled.Text style={{ whiteSpace: "nowrap" }}>
                                {maskHelper.resolveMask(
                                  facility.percLnSizeTotal,
                                  maskHelper.getPercentage(authContext.region, 5, "100.00", "0", true),
                                  /% (\d+\.\d+)/,
                                  "$1 %"
                                )}
                              </Styled.Text>
                            </Styled.TableColumn>
                          </Styled.TableRow>
                        </Styled.TableBody>
                      </Styled.Table>
                    </div>
                  </>
                ))}

                <Styled.RowLockAndSave style={{ marginTop: 40, marginBottom: 100 }}>
                  <Col style={{ maxWidth: 210 }}>
                    <Label>
                      <strong style={{ fontWeight: 600, fontSize: 15 }}>Lock above information from editing?</strong>
                    </Label>
                  </Col>

                  <Col>
                    <Styled.BorderSwitch>
                      <Field
                        disabled={isClient || (endorsmentType && endorsmentType !== "declaration" && endorsmentType !== "market-changes") || isBound}
                        component={Switch}
                        height={27}
                        width={55}
                        name={"lock"}
                        checked={formikProps.values.lock}
                        onChange={(a) => {
                          setFacilities(formikProps.values.facilities);

                          if (!a) return handleLock(a, formikProps.values);

                          buildValidation(null, false)
                            .validate(formikProps.values, { abortEarly: false })
                            .then(() => {
                              handleLock(a, formikProps.values);
                            })
                            .catch((e) => {
                              mc.error("Please, fill in all required fields.");
                            });
                        }}
                        handleDiameter={20}
                        checkedIcon={false}
                        uncheckedIcon={false}
                        offColor={Colors.WHITE}
                        onColor={Colors.GRAY[6]}
                        offHandleColor={Colors.GRAY[6]}
                        onHandleColor={Colors.WHITE}
                      />
                    </Styled.BorderSwitch>
                  </Col>
                </Styled.RowLockAndSave>

                <HasPermission permission={formikProps.values.lock && questionnaire?.length}>
                  <>
                    <FormContainer title="Coverages" show={formikProps.values.lock}>
                      <ObligorPercSection.components.RenderSection
                        disableAll={isBound || !formikProps.values.lock || ![26, 410, 398, 400].includes(operation?.idDomain)}
                        formikProps={formikProps}
                        formikRef={formik}
                        idOperation={props.match?.params?.idOperation}
                        idOperationParent={props.match?.params?.idOperationParent}
                        idProduct={idProduct}
                        isBound={isBound}
                        isMAS={isMAS}
                        isNewYork={isNewYork}
                        obligorGroup={obligorGroup}
                        setObligorGroup={setObligorGroup}
                        globalQuestionnaire={questionnaire}
                        setGlobalQuestionnaire={setQuestionnaire}
                        questionnaireAnswersToDelete={questionnaireAnswersToDelete}
                        setQuestionnaireAnswersToDelete={setQuestionnaireAnswersToDelete}
                        mc={mc}
                      />
                    </FormContainer>

                    <FormContainer title="Taxes" show={formikProps.values.lock}>
                      <HasPermission permission={isQuestionnaireLoaded}>
                        <TaxesRatesBasisGroupSection.components.RenderSection
                          legacyFormSection
                          disableAll={isBound || !formikProps.values.lock || ![26, 410, 398, 400].includes(operation?.idDomain)}
                          formikRef={formik}
                          values={formikProps.values}
                          setFieldValue={formikProps.setFieldValue}
                          errors={formikProps.errors}
                          setFieldError={formikProps.setFieldError}
                          idProduct={idProduct}
                          idOperation={props.match?.params?.idOperation}
                          idOperationParent={props.match?.params?.idOperationParent}
                          globalQuestionnaire={questionnaire}
                          setGlobalQuestionnaire={setQuestionnaire}
                          questionnaireAnswersToDelete={questionnaireAnswersToDelete}
                          setQuestionnaireAnswersToDelete={setQuestionnaireAnswersToDelete}
                          useGetQuestionnairesAnswersData={useGetQuestionnairesAnswersData}
                          useGetQuestionnairesAnswersStatus={useGetQuestionnairesAnswersStatus}
                          operation={operation}
                          loading={loading}
                          mc={mc}
                          insurerGroup={insurerGroup}
                          feePayableByGroup={feePayableByGroup}
                          setInsurerGroup={setInsurerGroup}
                          setFeePayableByGroup={setFeePayableByGroup}
                        />
                      </HasPermission>
                    </FormContainer>

                    <HasPermission permission={[26, 410].includes(operation?.idDomain)}>
                      <FormContainer title="Risk Details" show={formikProps.values.lock}>
                        <RiskDetailsFacilitySection.components.RenderSection
                          disableAll={isBound || !formikProps.values.lock || ![26, 410].includes(operation?.idDomain)}
                          formikProps={formikProps}
                          formikRef={formik}
                          idProduct={idProduct}
                          idOperation={props.match?.params?.idOperation}
                          idOperationParent={props.match?.params?.idOperationParent}
                          globalQuestionnaire={questionnaire}
                        />

                        <RiskDetailsSection.components.RenderSection
                          disableAll={isBound || !formikProps.values.lock || ![26, 410].includes(operation?.idDomain)}
                          formikProps={formikProps}
                          formikRef={formik}
                          idProduct={idProduct}
                          idOperation={props.match?.params?.idOperation}
                          idOperationParent={props.match?.params?.idOperationParent}
                          globalQuestionnaire={questionnaire}
                        />

                        <LossPayeeSection.components.RenderSection
                          disableAll={isBound || !formikProps.values.lock || ![26, 410].includes(operation?.idDomain)}
                          formikProps={formikProps}
                          formikRef={formik}
                          idProduct={idProduct}
                          idOperation={props.match?.params?.idOperation}
                          idOperationParent={props.match?.params?.idOperationParent}
                          globalQuestionnaire={questionnaire}
                          lossPayeeGroup={lossPayeeGroup}
                          setLossPayeeGroup={setLossPayeeGroup}
                          questionnaireAnswersToDelete={questionnaireAnswersToDelete}
                          setQuestionnaireAnswersToDelete={setQuestionnaireAnswersToDelete}
                        />
                      </FormContainer>

                      <FormContainer title="Information" show={formikProps.values.lock}>
                        <InformationSection.components.RenderSection
                          disableAll={isBound || !formikProps.values.lock || ![26, 410].includes(operation?.idDomain)}
                          formikProps={formikProps}
                          formikRef={formik}
                          idProduct={idProduct}
                          idOperation={props.match?.params?.idOperation}
                          idOperationParent={props.match?.params?.idOperationParent}
                          globalQuestionnaire={questionnaire}
                        />
                      </FormContainer>

                      <FormContainer title="Security Details" show={formikProps.values.lock}>
                        <SecurityDetailsSection.components.RenderSection
                          disableAll={isBound || !formikProps.values.lock || ![26, 410].includes(operation?.idDomain)}
                          formikProps={formikProps}
                          formikRef={formik}
                          idProduct={idProduct}
                          idOperation={props.match?.params?.idOperation}
                          idOperationParent={props.match?.params?.idOperationParent}
                          globalQuestionnaire={questionnaire}
                        />

                        <PartysSection.components.RenderSection
                          disableAll={isBound || !formikProps.values.lock || ![26, 410].includes(operation?.idDomain)}
                          formikProps={formikProps}
                          formikRef={formik}
                          idProduct={idProduct}
                          idOperation={props.match?.params?.idOperation}
                          idOperationParent={props.match?.params?.idOperationParent}
                          globalQuestionnaire={questionnaire}
                          setQuestionnaire={setQuestionnaire}
                        />
                      </FormContainer>

                      <FormContainer title="Subscription Agreement" show={formikProps.values.lock}>
                        <SubscriptionAgreementSection.components.RenderSection
                          disableAll={isBound || !formikProps.values.lock || ![26, 410].includes(operation?.idDomain)}
                          formikProps={formikProps}
                          formikRef={formik}
                          idProduct={idProduct}
                          idOperation={props.match?.params?.idOperation}
                          idOperationParent={props.match?.params?.idOperationParent}
                          globalQuestionnaire={questionnaire}
                        />
                      </FormContainer>

                      <FormContainer title="Fiscal and Regulatory" show={formikProps.values.lock}>
                        <FiscalAndRegulatorySection.components.RenderSection
                          disableAll={isBound || !formikProps.values.lock || ![26, 410].includes(operation?.idDomain)}
                          formikProps={formikProps}
                          formikRef={formik}
                          idProduct={idProduct}
                          idOperation={props.match?.params?.idOperation}
                          idOperationParent={props.match?.params?.idOperationParent}
                          globalQuestionnaire={questionnaire}
                        />
                      </FormContainer>

                      <FormContainer title="Broker Remuneration and Deductions" show={formikProps.values.lock}>
                        <BrokerRemunerationFeeClientSection.components.RenderSection
                          disableAll={isBound || !formikProps.values.lock || ![26, 410].includes(operation?.idDomain)}
                          formikProps={formikProps}
                          formikRef={formik}
                          idProduct={idProduct}
                          idOperation={props.match?.params?.idOperation}
                          idOperationParent={props.match?.params?.idOperationParent}
                          globalQuestionnaire={questionnaire}
                          setShowBrokerRemunerationSection={setShowBrokerRemunerationSection}
                          brokerRemunerationGroup={brokerRemunerationGroup}
                          setBrokerRemunerationGroup={setBrokerRemunerationGroup}
                          questionnaireAnswersToDelete={questionnaireAnswersToDelete}
                          setQuestionnaireAnswersToDelete={setQuestionnaireAnswersToDelete}
                        />

                        {showBrokerRemunerationSection && (
                          <BrokerRemunerationSection.components.RenderSection
                            disableAll={isBound || !formikProps.values.lock || ![26, 410].includes(operation?.idDomain)}
                            formikProps={formikProps}
                            formikRef={formik}
                            idProduct={idProduct}
                            idOperation={props.match?.params?.idOperation}
                            idOperationParent={props.match?.params?.idOperationParent}
                            globalQuestionnaire={questionnaire}
                            brokerRemunerationGroup={brokerRemunerationGroup}
                            setBrokerRemunerationGroup={setBrokerRemunerationGroup}
                            questionnaireAnswersToDelete={questionnaireAnswersToDelete}
                            setQuestionnaireAnswersToDelete={setQuestionnaireAnswersToDelete}
                          />
                        )}

                        <BrokerRemunerationOtherSection.components.RenderSection
                          disableAll={isBound || !formikProps.values.lock || ![26, 410].includes(operation?.idDomain)}
                          formikProps={formikProps}
                          formikRef={formik}
                          idProduct={idProduct}
                          idOperation={props.match?.params?.idOperation}
                          idOperationParent={props.match?.params?.idOperationParent}
                          globalQuestionnaire={questionnaire}
                          setShowBrokerRemunerationDeductionSection={setShowBrokerRemunerationDeductionSection}
                          brokerRemunerationDeductionGroup={brokerRemunerationDeductionGroup}
                          setBrokerRemunerationDeductionGroup={setBrokerRemunerationDeductionGroup}
                          questionnaireAnswersToDelete={questionnaireAnswersToDelete}
                          setQuestionnaireAnswersToDelete={setQuestionnaireAnswersToDelete}
                        />

                        {showBrokerRemunerationDeductionSection && (
                          <BrokerRemunerationDeductionSection.components.RenderSection
                            disableAll={isBound || !formikProps.values.lock || ![26, 410].includes(operation?.idDomain)}
                            formikProps={formikProps}
                            formikRef={formik}
                            idProduct={idProduct}
                            idOperation={props.match?.params?.idOperation}
                            idOperationParent={props.match?.params?.idOperationParent}
                            globalQuestionnaire={questionnaire}
                            brokerRemunerationDeductionGroup={brokerRemunerationDeductionGroup}
                            setBrokerRemunerationDeductionGroup={setBrokerRemunerationDeductionGroup}
                            questionnaireAnswersToDelete={questionnaireAnswersToDelete}
                            setQuestionnaireAnswersToDelete={setQuestionnaireAnswersToDelete}
                          />
                        )}
                      </FormContainer>

                      {endorsmentType && endorsmentType === 'declaration' && (
                        <FormContainer title="Declaration Template" show={formikProps.values.lock}>
                          <DeclarationTemplateSection.components.RenderSection
                            disableAll={isBound || !formikProps.values.lock || ![26, 410].includes(operation?.idDomain)}
                            formikProps={formikProps}
                            formikRef={formik}
                            idProduct={idProduct}
                            idOperation={props.match?.params?.idOperation}
                            idOperationParent={props.match?.params?.idOperationParent}
                            globalQuestionnaire={questionnaire}
                          />
                        </FormContainer>
                      )}
                    </HasPermission>
                  </>
                </HasPermission>
              </Styled.ScrollBox>

              <ButtonContainer>
                <Button
                  style={{ padding: "0.75rem 0" }}
                  forth
                  onClick={() => {
                    history.goBack();
                  }}
                >
                  &lt; Back
                </Button>

                <HasPermission permission={!isBound}>
                  <RenderButtons idOperation={props.match?.params?.idOperation}>
                    <Styled.ButtonContent>
                      <div style={{ marginTop: "5px" }}>
                        <LostCancelButton idOperation={props.match?.params?.idOperation} />
                      </div>

                      {!endorsmentType && renderFlowClient(formikProps)}

                      {endorsmentType && (
                        <>
                          {(endorsmentType === "market-changes" || endorsmentType === "declaration") && (
                            <Button third style={{ marginLeft: "10px", marginTop: "5px" }} onClick={(e) => handleCreateMarketChangeQuotation()}>
                              UPDATE NBI
                            </Button>
                          )}
                        </>
                      )}

                      <HasPermission permission={[26, 410, 398, 400].includes(operation?.idDomain) && formikProps.values.lock}>
                        <Button
                          third
                          style={{ marginLeft: "10px", marginTop: "5px" }}
                          onClick={() => GeneralSection.events.handleSave({
                            values: formikProps.values,
                            questionnaire,
                            obligorGroup,
                            insurerGroup,
                            feePayableByGroup,
                            lossPayeeGroup,
                            brokerRemunerationGroup,
                            brokerRemunerationDeductionGroup,
                            idOperation: props.match?.params?.idOperation,
                            idOperationParent: props.match?.params?.idOperationParent,
                            SECTIONS,
                            isDraft: true,
                            mc,
                            formikRef: formik,
                            refQuestionnaireSent,
                            useGetQuestionnairesAnswersRequest,
                            useSaveQuestionnaireAnswerRequest,
                            questionnaireAnswersToDelete,
                            useDeleteQuestionnaireAnswerRequest,
                            submitFunction: null
                          })}
                        >
                          SAVE
                        </Button>

                        <Button
                          primary
                          style={{ marginLeft: "10px", marginTop: "5px" }}
                          onClick={() => GeneralSection.events.handleSave({
                            values: formikProps.values,
                            questionnaire,
                            obligorGroup,
                            insurerGroup,
                            feePayableByGroup,
                            lossPayeeGroup,
                            brokerRemunerationGroup,
                            brokerRemunerationDeductionGroup,
                            idOperation: props.match?.params?.idOperation,
                            idOperationParent: props.match?.params?.idOperationParent,
                            SECTIONS,
                            isDraft: false,
                            mc,
                            formikRef: formik,
                            refQuestionnaireSent,
                            useGetQuestionnairesAnswersRequest,
                            useSaveQuestionnaireAnswerRequest,
                            questionnaireAnswersToDelete,
                            useDeleteQuestionnaireAnswerRequest,
                            submitFunction: generateContract
                          })}
                        >
                          {endorsmentType && endorsmentType !== "declaration" ? 'GENERATE ENDORS. DOC' : 'CONTRACT'}
                        </Button>
                      </HasPermission>
                    </Styled.ButtonContent>
                  </RenderButtons>
                </HasPermission>
              </ButtonContainer>
            </Form>
          )}
        />

        <HasPermission permission={!!insurerContacts?.idPersonInsurer}>
          <ModalContacts
            show={modalUnderwriter}
            onModalClose={() => {
              setSelectedUnderwriters([]);
              setModalUnderwriter(false);
            }}
            onConfirm={() => handleUpdateNBIManually(insurerContacts, selectedUnderwriters)}
          >
            <Row style={{ marginBottom: "10px" }}>
              <Styled.Title>SELECT UNDERWRITERS TO NOTIFY THEM ABOUT THE CHANGES</Styled.Title>
            </Row>

            <Row>
              <Col md={12} sm={12}>
                <Styled.Title>TO</Styled.Title>

                <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
                  <Styled.Title>{insurerContacts?.insurerFirstName}</Styled.Title>
                </Row>

                <Styled.ScrollBox>
                  <Styled.Table>
                    <Styled.TableHead>
                      <Styled.TableRow>
                        <Styled.TableHeader></Styled.TableHeader>
                        <Styled.TableHeader>
                          <GridColumnTitle style={{ textTransform: "uppercase" }}>Legal Entity</GridColumnTitle>
                        </Styled.TableHeader>
                        <Styled.TableHeader>
                          <GridColumnTitle style={{ textTransform: "uppercase" }}>Name</GridColumnTitle>
                        </Styled.TableHeader>
                        <Styled.TableHeader>
                          <GridColumnTitle style={{ textTransform: "uppercase" }}>Department</GridColumnTitle>
                        </Styled.TableHeader>
                        <Styled.TableHeader style={{ textAlign: "center" }}>
                          <GridColumnTitle style={{ textTransform: "uppercase" }}>E-mail</GridColumnTitle>
                        </Styled.TableHeader>
                      </Styled.TableRow>
                    </Styled.TableHead>
                    <Styled.TableBody>
                      {insurerContacts?.contacts.length ? (
                        insurerContacts?.contacts.map((contact) => (
                          <Styled.TableRow key={contact.idContact}>
                            <Styled.TableColumn>
                              <label>
                                <CheckBox
                                  onChange={() => handleSelectUnderwriter(contact)}
                                  checked={selectedUnderwriters.find((item) => item.idContact === contact.idContact) ? true : false}
                                />
                              </label>
                            </Styled.TableColumn>
                            <Styled.TableColumn>
                              <Styled.InlineLabel>Legal Entity</Styled.InlineLabel>
                              <Styled.LabelEdit>{contact.legalEntity}</Styled.LabelEdit>
                            </Styled.TableColumn>
                            <Styled.TableColumn>
                              <Styled.InlineLabel>Name</Styled.InlineLabel>
                              <Styled.LabelEdit>{contact.nameContact}</Styled.LabelEdit>
                            </Styled.TableColumn>
                            <Styled.TableColumn>
                              <Styled.InlineLabel>Department</Styled.InlineLabel>
                              <Styled.LabelEdit>{contact.personContactDepartment}</Styled.LabelEdit>
                            </Styled.TableColumn>
                            <Styled.TableColumn>
                              <Styled.InlineLabel>E-mail</Styled.InlineLabel>
                              <Styled.LabelEdit>{contact.email}</Styled.LabelEdit>
                            </Styled.TableColumn>
                          </Styled.TableRow>
                        ))
                      ) : (
                        <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
                          <Label>No results found.</Label>
                        </Row>
                      )}
                    </Styled.TableBody>
                  </Styled.Table>
                </Styled.ScrollBox>
              </Col>
            </Row>
          </ModalContacts>
        </HasPermission>

        <HasPermission permission={loading.active}>
          <Loader backdropColor={Colors.WHITE} fullScreen />
        </HasPermission>
      </ContentCard>
    </Layout>
  );
}
